import React, { Component } from "react";
import Card from "../../component/Card";
import FilterForm from "./FilterForm";
import Print from "../Print";
import { getSexString, getVisitTypeName } from "../../../helper/helper";
import Export from "../Export";
import ReactToPrint from "react-to-print";
import Table from "../../component/Table";
import TableServerSidePagination from "../../component/ServerSideTable/TableServerSidePagination";
import withContext from "../../hoc/withContext";
import { SkdrContext } from "../Context";
import { InlineLoading } from "../../component/Loading";
import { setAgeFromVisit } from "view/component/helper/helper";

class Skdr extends Component {
  printComponentRef = React.createRef();

  printedBody = document.body.innerHTML;
  generateralan(data) {
    let ralan = data.filter((a) => a.tipe < 3);
    let total = 0;
    ralan.map((a) => {
      total += a.jumlah;
    });
    return total;
  }
  generateranap(data) {
    let ranap = data.find((a) => a.tipe == 3);
    let total = ranap ? ranap.jumlah : 0;

    return total;
  }
  generateTotal(data) {
    let total = 0;
    data.map((a) => {
      total += a.jumlah;
    });
    return total;
  }
  render() {
    const { store } = this.context;
    console.log(store);
    return (
      <div className="container-fluid my-3">
        <Card>
          <Card.Body>
            <FilterForm />
          </Card.Body>
        </Card>
        <Card>
          <Card.Body>
            <div className="d-flex justify-content-left my-2">
              <Export
                csvData={store.dataKunjungan.data}
                disabled={
                  !store.dataKunjungan?.data || store.onLoad ? true : false
                }
                fileName={"laporan_skdr"}
                columnMapper={(data) => {
                  return {
                    Penyakit: data[0].nama,
                    "Rawat Jalan": this.generateralan(data),
                    "Rawat Inap": this.generateranap(data),
                    "Jumlah Kasus": this.generateTotal(data),
                  };
                }}
              />
              <ReactToPrint
                trigger={() => (
                  <button
                    disabled={
                      !store.dataKunjungan?.data || store.onLoad ? true : false
                    }
                    className="btn btn-primary"
                  >
                    Cetak SKDR
                  </button>
                )}
                content={() => this.printComponentRef.current}
                pageStyle={{ overflow: "visible" }}
                copyStyles={true}
              />
              <div className="my-auto">
                <InlineLoading
                  isLoading={store.onLoad}
                  textInfo="Mengunduh Dokumen..."
                />
              </div>
            </div>
            <Table
              isLoading={store.onLoad}
              isBordered={true}
              headers={[
                "No",
                "Penyakit",
                "Rawat Jalan",
                "Rawat Inap",
                "Jumlah Kasus",
              ]}
              columnMapper={(data) => [
                data[0].nama,
                this.generateralan(data),
                this.generateranap(data),
                this.generateTotal(data),
              ]}
              pagination={false}
              data={store.dataKunjungan?.data}
            />
          </Card.Body>
        </Card>
        <div className="d-none">
          <Print
            ref={this.printComponentRef}
            datas={store.dataKunjungan?.data}
            headers={[
              "No",
              "Penyakit",
              "Rawat Jalan",
              "Rawat Inap",
              "Jumlah Kasus",
            ]}
            columnMapper={(data) => [
              data[0].nama,
              this.generateralan(data),
              this.generateranap(data),
              this.generateTotal(data),
            ]}
            pagination={false}
          />
        </div>
      </div>
    );
  }
}

Skdr.contextType = SkdrContext;

export default withContext(SkdrContext, {
  dataKunjungan: "",
  onLoad: false,
})(Skdr);
